"use strict";
var Observable_1 = require('../../Observable');
var never_1 = require('../../observable/never');
Observable_1.Observable.never = never_1.never;
//# sourceMappingURL=never.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/rxjs/add/observable/never.js
// module id = ./node_modules/rxjs/add/observable/never.js
// module chunks = 0